const encodeNode = <T>(json: T) =>
  typeof json !== 'undefined' ? Buffer.from(JSON.stringify(json)).toString('base64') : ''

const encodeBrowser = <T>(json: T) =>
  typeof json !== 'undefined' ? btoa(JSON.stringify(json)) : ''

export const encode = <T>(json: T) =>
  typeof Buffer !== 'undefined' ? encodeNode(json) : encodeBrowser(json)
